<template>
  <v-card>
    <v-toolbar flat>
      <div>
        <v-toolbar-title class="text-h6 font-weight-regular">Select a transformation you want to apply to this CSV Data</v-toolbar-title>
        <v-subheader>You do not have to select any tranforms if the CSV has at minimum an email column and you do not need to map to DMS data</v-subheader>
      </div>
    </v-toolbar>
    <v-card-text>
      <!-- MATCHING STEPS -->
      <p class="text-subtitle-1 font-weight-medium">MATCHING</p>
      <v-radio-group v-model="matchingStep" class="ml-6">
        <template v-for="tStep in groupSteps()(matchingGroupName)">
          <v-radio :key="tStep.component" :value="tStep.name">
            <template v-slot:label>
              <span v-html="tStep.description"></span>
            </template>
          </v-radio>
        </template>
      </v-radio-group>

      <!-- ROI STEPS -->
      <p class="text-subtitle-1 font-weight-medium">ROI</p>
      <v-radio-group v-model="roiStep" class="ml-6">
        <template v-for="tStep in groupSteps()(roiGroupName)">
          <v-radio :key="tStep.component" :value="tStep.name">
            <template v-slot:label>
              <span v-html="tStep.description"></span>
            </template>
          </v-radio>
        </template>
      </v-radio-group>
    </v-card-text>
  </v-card>
</template>

<script>
import StepHelperMixin from './StepHelperMixin'
import { clone } from 'ramda'
import { mapState, mapMutations, mapGetters } from 'vuex'
import { MATCHING_GROUP, ROI_GROUP } from '@/store/modules/CsvMappingStore'

export default {
  name: 'select-csv-transforms',
  mixins: [StepHelperMixin],
  data: function () {
    return {
      matchingGroupName: MATCHING_GROUP,
      roiGroupName: ROI_GROUP
    }
  },
  computed: {
    ...mapState('CsvMappingStore', ['workflowSteps', 'selectedOptionalSteps']),
    matchingStep: {
      get () {
        return this.selectedOptionalSteps[this.optionalGroupStepIndex()(this.matchingGroupName)]
      },
      set (val) {
        const nos = clone(this.selectedOptionalSteps)
        nos[this.optionalGroupStepIndex()(this.matchingGroupName)] = val
        this.updateOptionalSteps(nos)
      }
    },
    roiStep: {
      get () {
        return this.selectedOptionalSteps[this.optionalGroupStepIndex()(this.roiGroupName)]
      },
      set (val) {
        const nos = clone(this.selectedOptionalSteps)
        nos[this.optionalGroupStepIndex()(this.roiGroupName)] = val
        this.updateOptionalSteps(nos)
      }
    }
  },
  methods: {
    ...mapMutations('CsvMappingStore', ['updateOptionalSteps']),
    ...mapGetters('CsvMappingStore', ['groups', 'groupSteps', 'optionalGroupStepIndex']),
    validateStep () {
      // no validation - can always continue
      this.setStepIsValid(true)
    }
  }
}
</script>
